import types from "./types";

const INITIAL_STATE = {
  requestList: null,
  requestListError: null,
  requestListLoading: false,

  //create
  createrequest: null,
  createrequestError: null,
  createrequestLoading: false,

  //update
  updaterequest: null,
  updaterequestError: null,
  updaterequestLoading: false,

  //delete
  deleterequest: null,
  deleterequestError: null,
  deleterequestLoading: false,

  //single item
  singleItem: null,
};

const requestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_REQUEST_START:
      return {
        ...state,
        requestList: null,
        requestListError: null,
        requestListLoading: true,
      };
    case types.GET_REQUEST_SUCCESS:
      return {
        ...state,
        requestList: action.payload,
        requestListLoading: false,
      };
    case types.GET_REQUEST_ERROR:
      return {
        ...state,
        requestListError: action.payload,
        requestListLoading: false,
      };
    case types.GET_REQUEST_RESET:
      return {
        ...state,
        requestListError: null,
        requestListLoading: false,
      };
    //create

    case types.CREATE_REQUEST_START:
      return {
        ...state,
        createrequest: null,
        createrequestError: null,
        createrequestLoading: true,
      };
    case types.CREATE_REQUEST_SUCCESS:
      return {
        ...state,
        createrequest: action.payload,
        createrequestLoading: false,
      };
    case types.CREATE_REQUEST_ERROR:
      return {
        ...state,
        createrequestError: action.payload,
        createrequestLoading: false,
      };
    case types.CREATE_REQUEST_RESET:
      return {
        ...state,
        createrequestError: null,
        createrequestLoading: false,
      };
    //delete

    case types.DELETE_REQUEST_START:
      return {
        ...state,
        deleterequest: null,
        deleterequestError: null,
        deleterequestLoading: true,
      };
    case types.DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        deleterequest: action.payload,
        deleterequestLoading: false,
      };
    case types.DELETE_REQUEST_ERROR:
      return {
        ...state,
        deleterequestError: action.payload,
        deleterequestLoading: false,
      };
    case types.DELETE_REQUEST_RESET:
      return {
        ...state,
        deleterequest: null,
        deleterequestError: null,
        deleterequestLoading: false,
      };

    //update
    case types.UPDATE_REQUEST_START:
      return {
        ...state,
        updaterequest: null,
        updaterequestError: null,
        updaterequestLoading: true,
      };
    case types.UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        updaterequest: action.payload,
        updaterequestLoading: false,
      };
    case types.UPDATE_REQUEST_ERROR:
      return {
        ...state,
        updaterequestError: action.payload,
        updaterequestLoading: false,
      };
    case types.UPDATE_REQUEST_RESET:
      return {
        ...state,
        updaterequest: null,
        updaterequestError: null,
        updaterequestLoading: false,
      };
    //singleItem
    case types.SINGLE_REQUEST_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_REQUEST_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_REQUEST_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_REQUEST_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default requestReducer;

